import React from 'react';
import { useAppDispatch } from '@hooks/statehooks';

import { updateSelectedTab } from '@store/reducers/tabs';

import Typography from '@components/typography';

interface TabTitleProps {
  title: string;
  index: number;
  name: string;
  selectedTab: number;
}

const TabTitle: React.FC<TabTitleProps> = ({
  title,
  index,
  selectedTab,
  name,
}) => {
  const dispatch = useAppDispatch();

  return (
    <li
      className={`tab tab__border ${selectedTab === index ? 'active' : ''}`}
      role="tab"
      onClick={() => dispatch(updateSelectedTab({ name, index }))}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          dispatch(updateSelectedTab({ name, index }));
        }
      }}
      tabIndex={0}
    >
      <Typography variant="caption" size="rg">
        {title}
      </Typography>
    </li>
  );
};

export default TabTitle;
